/** Return an object with the keys of values that appear more than once are removed */
export function checkConfig<T>(paths: Record<string, T>): Record<string, T> {
    const map = new Map()
    for (const v of Object.values(paths)) {
        map.set(v, (map.get(v) ?? 0) + 1)
    }
    const result = {...paths}
    Object.entries(paths).forEach((v, k) => {
        if (map.get(v) !== 1) {
            delete result[k]
        }
    })
    return result
}
